import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Navbar from '../Component/Navbar'

const OL       = '#6b7c3e'
const OL_LIGHT = '#8a9e52'
const OL_PALE  = '#f0f4e8'
const OL_HEADER= '#e8eedd'
const OL_DARK  = '#3d4a22'

const navItems = [
    { label: 'Dashboard', icon: '📊', path: '/dashboard' },
    { label: 'Trip Details', icon: '🚚', path: '/trip-details' },
    { label: 'Saved Address', icon: '📍', path: '/save-address' },
    { label: 'Employee Details', icon: '👤', path: '/employee-request' },
    { label: 'Branch Details', icon: '🏢', path: '/branch-details' },
    { label: 'Account', icon: '📋', path: '/account' },
]

const Account = () => {
    const navigate = useNavigate()
    const [activeNav, setActiveNav] = useState('Account')

    const enterpriseData = JSON.parse(localStorage.getItem("enterpriseData") || "{}")

    const [profile, setProfile] = useState({
        userName: enterpriseData?.enterpriseName || '',
        email:    enterpriseData?.email          || '',
    })

    const [bank, setBank] = useState({
        beneficiaryName: enterpriseData?.enterpriseName  || '',
        gstNumber:       enterpriseData?.gstNumber       || '',
        panCard:         enterpriseData?.pancardNumber   || '',
        upiId:           enterpriseData?.upiId           || '',
        bankName:        enterpriseData?.bankName        || '',
        bankAccountNumber: enterpriseData?.bankAccountNumber || '',
        bankIfscCode:    enterpriseData?.bankIfscCode    || '',
    })

    const [notifications, setNotifications] = useState({
        emailNotification: false,
        softwareUpdate: false,
        billingPayments: false,
        termsConditions: false,
    })

    const [deliveryCode, setDeliveryCode] = useState(false)

    const handleProfileChange   = (e) => setProfile({ ...profile, [e.target.name]: e.target.value })
    const handleBankChange      = (e) => setBank({ ...bank, [e.target.name]: e.target.value })
    const handleNotifToggle     = (key) => setNotifications({ ...notifications, [key]: !notifications[key] })

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
                * { box-sizing: border-box; margin: 0; padding: 0; }
                body { font-family: 'DM Sans', sans-serif; }
                .ac-nav-btn:hover   { background: ${OL_PALE} !important; color: ${OL_DARK} !important; }
                .ac-input:focus     {
                    border-color: ${OL} !important;
                    box-shadow: 0 0 0 3px rgba(107,124,62,0.12) !important;
                    outline: none;
                }
                .ac-save-btn:hover  { background: ${OL_LIGHT} !important; }
                .ac-logout:hover    { background: #fee2e2 !important; color: #b91c1c !important; border-color: #fca5a5 !important; }
                .ac-toggle:checked  { background: ${OL} !important; border-color: ${OL} !important; }
                .notif-row:hover    { background: #fafdf7 !important; }
            `}</style>

            <Navbar />

            <div style={S.shell}>

                {/* ── Sidebar ── */}
                <aside style={S.sidebar}>
                    <div style={S.sidebarLogo}>
                        <span style={S.logoIcon}>🚛</span>
                        <span style={S.logoText}>Menu</span>
                    </div>
                    <nav style={S.nav}>
                        {navItems.map((item) => (
                            <button
                                key={item.label}
                                className="ac-nav-btn"
                                style={{
                                    ...S.navItem,
                                    ...(activeNav === item.label ? S.navItemActive : {}),
                                }}
                                onClick={() => {
                                    setActiveNav(item.label)
                                    if (item.path) navigate(item.path)
                                }}
                            >
                                <span style={S.navIcon}>{item.icon}</span>
                                <span>{item.label}</span>
                                {activeNav === item.label && <span style={S.navIndicator} />}
                            </button>
                        ))}
                    </nav>
                </aside>

                {/* ── Main ── */}
                <main style={S.main}>

                    {/* Page Header */}
                    <div style={S.pageHeader}>
                        <div>
                            <h1 style={S.title}>Account Settings</h1>
                            <p style={S.subtitle}>Manage your profile, bank details and notifications</p>
                        </div>
                        <button className="ac-logout" style={S.logoutBtn}>
                            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
                            </svg>
                            Log Out
                        </button>
                    </div>

                    <div style={S.contentCol}>

                        {/* ── Delivery Code Card ── */}
                        <div style={S.card}>
                            <div style={S.cardRow}>
                                <div>
                                    <div style={S.cardTitle}>Delivery Code-based Confirmation</div>
                                    <div style={S.cardDesc}>
                                        The recipient must provide the delivery code to the driver partner to confirm receipt.
                                    </div>
                                </div>
                                <label style={S.switchWrap}>
                                    <input
                                        type="checkbox"
                                        checked={deliveryCode}
                                        onChange={() => setDeliveryCode(!deliveryCode)}
                                        style={{ display: 'none' }}
                                    />
                                    <div style={{
                                        ...S.switchTrack,
                                        background: deliveryCode ? OL : '#d1d5db',
                                    }}>
                                        <div style={{
                                            ...S.switchThumb,
                                            transform: deliveryCode ? 'translateX(22px)' : 'translateX(2px)',
                                        }} />
                                    </div>
                                </label>
                            </div>
                        </div>

                        {/* ── Profile Details Card ── */}
                        <div style={S.card}>
                            <div style={S.sectionHeader}>
                                <span style={S.sectionIcon}>👤</span>
                                <span style={S.sectionTitle}>Profile Details</span>
                            </div>
                            <div style={S.formGrid}>
                                <div style={S.formGroup}>
                                    <label style={S.label}>USER NAME</label>
                                    <input
                                        className="ac-input"
                                        style={S.input}
                                        name="userName"
                                        value={profile.userName}
                                        onChange={handleProfileChange}
                                        placeholder="Your name"
                                    />
                                </div>
                                <div style={S.formGroup}>
                                    <label style={S.label}>REGISTERED EMAIL ID</label>
                                    <input
                                        className="ac-input"
                                        style={{ ...S.input, background: '#f3f4f6', color: '#9ca3af' }}
                                        name="email"
                                        value={profile.email}
                                        readOnly
                                        placeholder="Email address"
                                    />
                                </div>
                                <div style={S.formGroup}>
                                    <label style={S.label}>PHONE NUMBER</label>
                                    <input
                                        className="ac-input"
                                        style={{ ...S.input, background: '#f3f4f6', color: '#9ca3af' }}
                                        name="phone"
                                        value={enterpriseData?.phone || ''}
                                        readOnly
                                        placeholder="Phone number"
                                    />
                                </div>
                                <div style={S.formGroup}>
                                    <label style={S.label}>ENTERPRISE TYPE</label>
                                    <input
                                        className="ac-input"
                                        style={{ ...S.input, background: '#f3f4f6', color: '#9ca3af' }}
                                        name="enterpriseType"
                                        value={enterpriseData?.enterpriseType || ''}
                                        readOnly
                                        placeholder="Enterprise type"
                                    />
                                </div>
                                <div style={{ ...S.formGroup, gridColumn: '1 / -1' }}>
                                    <label style={S.label}>ADDRESS</label>
                                    <input
                                        className="ac-input"
                                        style={{ ...S.input, background: '#f3f4f6', color: '#9ca3af' }}
                                        name="address"
                                        value={
                                            [enterpriseData?.address, enterpriseData?.city, enterpriseData?.state]
                                                .filter(Boolean)
                                                .join(', ')
                                        }
                                        readOnly
                                        placeholder="Address"
                                    />
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                                <button className="ac-save-btn" style={S.saveBtn}>Save Profile</button>
                            </div>
                        </div>

                        {/* ── Primary Bank Details Card ── */}
                        <div style={S.card}>
                            <div style={S.sectionHeader}>
                                <span style={S.sectionIcon}>🏦</span>
                                <span style={S.sectionTitle}>Primary Bank Details</span>
                            </div>
                            <div style={S.formGrid}>
                                <div style={{ ...S.formGroup, gridColumn: '1 / -1' }}>
                                    <label style={S.label}>BENEFICIARY NAME</label>
                                    <input
                                        className="ac-input"
                                        style={S.input}
                                        name="beneficiaryName"
                                        value={bank.beneficiaryName}
                                        onChange={handleBankChange}
                                        placeholder="Account holder name"
                                    />
                                </div>
                                <div style={S.formGroup}>
                                    <label style={S.label}>BANK NAME</label>
                                    <input
                                        className="ac-input"
                                        style={S.input}
                                        name="bankName"
                                        value={bank.bankName}
                                        onChange={handleBankChange}
                                        placeholder="e.g. SBI"
                                    />
                                </div>
                                <div style={S.formGroup}>
                                    <label style={S.label}>BANK ACCOUNT NUMBER</label>
                                    <input
                                        className="ac-input"
                                        style={S.input}
                                        name="bankAccountNumber"
                                        value={bank.bankAccountNumber}
                                        onChange={handleBankChange}
                                        placeholder="e.g. 123456789012"
                                    />
                                </div>
                                <div style={S.formGroup}>
                                    <label style={S.label}>BANK IFSC CODE</label>
                                    <input
                                        className="ac-input"
                                        style={S.input}
                                        name="bankIfscCode"
                                        value={bank.bankIfscCode}
                                        onChange={handleBankChange}
                                        placeholder="e.g. SBIN0001234"
                                    />
                                </div>
                                <div style={S.formGroup}>
                                    <label style={S.label}>UPI ID</label>
                                    <input
                                        className="ac-input"
                                        style={S.input}
                                        name="upiId"
                                        value={bank.upiId}
                                        onChange={handleBankChange}
                                        placeholder="e.g. name@upi"
                                    />
                                </div>
                                <div style={S.formGroup}>
                                    <label style={S.label}>GST NUMBER</label>
                                    <input
                                        className="ac-input"
                                        style={S.input}
                                        name="gstNumber"
                                        value={bank.gstNumber}
                                        onChange={handleBankChange}
                                        placeholder="e.g. 27AAPFU0939F1ZV"
                                    />
                                </div>
                                <div style={S.formGroup}>
                                    <label style={S.label}>PAN CARD NUMBER</label>
                                    <input
                                        className="ac-input"
                                        style={S.input}
                                        name="panCard"
                                        value={bank.panCard}
                                        onChange={handleBankChange}
                                        placeholder="e.g. ABCDE1234F"
                                    />
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                                <button className="ac-save-btn" style={S.saveBtn}>Save Bank Details</button>
                            </div>
                        </div>

                        {/* ── Notification Settings Card ── */}
                        <div style={S.card}>
                            <div style={S.sectionHeader}>
                                <span style={S.sectionIcon}>🔔</span>
                                <span style={S.sectionTitle}>Notification Settings</span>
                            </div>
                            <div style={S.notifList}>
                                {[
                                    { key: 'emailNotification',  label: 'Email Notification',               desc: 'Receive updates and alerts via email' },
                                    { key: 'softwareUpdate',     label: 'Software Update Notifications',    desc: 'Get notified about new app updates' },
                                    { key: 'billingPayments',    label: 'Billing & Payments Notifications', desc: 'Alerts for invoices and payment status' },
                                    { key: 'termsConditions',    label: 'Terms & Conditions Update',        desc: 'Notify when terms are updated' },
                                ].map(({ key, label, desc }) => (
                                    <div key={key} className="notif-row" style={S.notifRow}
                                        onClick={() => handleNotifToggle(key)}
                                    >
                                        <div>
                                            <div style={S.notifLabel}>{label}</div>
                                            <div style={S.notifDesc}>{desc}</div>
                                        </div>
                                        <label style={S.switchWrap} onClick={(e) => e.stopPropagation()}>
                                            <input
                                                type="checkbox"
                                                checked={notifications[key]}
                                                onChange={() => handleNotifToggle(key)}
                                                style={{ display: 'none' }}
                                            />
                                            <div style={{
                                                ...S.switchTrack,
                                                background: notifications[key] ? OL : '#d1d5db',
                                            }}>
                                                <div style={{
                                                    ...S.switchThumb,
                                                    transform: notifications[key] ? 'translateX(22px)' : 'translateX(2px)',
                                                }} />
                                            </div>
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </main>
            </div>
        </>
    )
}

export default Account

// ─── Styles ────────────────────────────────────────────────────────────────────

const S = {
    shell: {
        display: 'flex',
        minHeight: '100vh',
        fontFamily: "'DM Sans', sans-serif",
        background: '#f7f8f4',
        color: '#2c2c2c',
    },
    sidebar: {
        width: 220,
        background: '#fff',
        borderRight: '1px solid #e0e5d4',
        display: 'flex',
        flexDirection: 'column',
        padding: '24px 0',
        flexShrink: 0,
        boxShadow: '2px 0 12px rgba(107,124,62,0.07)',
    },
    sidebarLogo: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '0 20px 24px',
        borderBottom: '1px solid #e8eedd',
        marginBottom: 12,
    },
    logoIcon: { fontSize: 22 },
    logoText: {
        fontSize: 18,
        fontWeight: 700,
        color: OL_DARK,
        letterSpacing: '-0.3px',
    },
    nav: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        padding: '0 10px',
    },
    navItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '10px 12px',
        borderRadius: 10,
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        fontSize: 14,
        fontWeight: 500,
        color: '#666',
        textAlign: 'left',
        position: 'relative',
        transition: 'all 0.18s ease',
        fontFamily: "'DM Sans', sans-serif",
    },
    navItemActive: {
        background: OL_PALE,
        color: OL_DARK,
        fontWeight: 600,
    },
    navIcon: { fontSize: 15 },
    navIndicator: {
        position: 'absolute',
        left: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        width: 3,
        height: 20,
        borderRadius: '0 3px 3px 0',
        background: OL,
    },

    // Main
    main: {
        flex: 1,
        padding: '32px 36px',
        overflow: 'auto',
    },
    pageHeader: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        marginBottom: 28,
    },
    title: {
        fontSize: 26,
        fontWeight: 700,
        color: OL_DARK,
        letterSpacing: '-0.5px',
    },
    subtitle: {
        fontSize: 13,
        color: '#888',
        marginTop: 3,
    },
    logoutBtn: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 7,
        border: '1.5px solid #e5e7eb',
        background: '#fff',
        color: '#4b5563',
        borderRadius: 9,
        padding: '9px 18px',
        fontSize: 14,
        fontWeight: 600,
        cursor: 'pointer',
        fontFamily: "'DM Sans', sans-serif",
        transition: 'all 0.15s',
        whiteSpace: 'nowrap',
    },
    contentCol: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        maxWidth: 860,
    },

    // Card
    card: {
        background: '#fff',
        borderRadius: 14,
        border: '1px solid #e2e8d4',
        padding: '22px 24px',
        boxShadow: '0 2px 16px rgba(107,124,62,0.06)',
    },
    cardRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 20,
    },
    cardTitle: {
        fontSize: 15,
        fontWeight: 700,
        color: OL_DARK,
        marginBottom: 4,
    },
    cardDesc: {
        fontSize: 13,
        color: '#888',
        lineHeight: 1.5,
    },

    // Section header inside card
    sectionHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: 9,
        marginBottom: 18,
        paddingBottom: 14,
        borderBottom: `1px solid ${OL_HEADER}`,
    },
    sectionIcon: { fontSize: 18 },
    sectionTitle: {
        fontSize: 16,
        fontWeight: 700,
        color: OL_DARK,
    },

    // Form
    formGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '14px 20px',
    },
    formGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
    },
    label: {
        fontSize: '0.72rem',
        fontWeight: 700,
        color: '#6b7280',
        letterSpacing: '0.05em',
    },
    input: {
        border: '1.5px solid #e0e5d4',
        borderRadius: 8,
        padding: '10px 13px',
        fontFamily: "'DM Sans', sans-serif",
        fontSize: '0.91rem',
        color: '#1f2937',
        background: OL_PALE,
        transition: 'border 0.13s, box-shadow 0.13s',
    },
    saveBtn: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        background: OL,
        color: '#fff',
        border: 'none',
        borderRadius: 8,
        padding: '9px 20px',
        fontSize: 13,
        fontWeight: 600,
        cursor: 'pointer',
        fontFamily: "'DM Sans', sans-serif",
        transition: 'background 0.15s',
    },

    // Toggle switch
    switchWrap: {
        cursor: 'pointer',
        flexShrink: 0,
    },
    switchTrack: {
        width: 46,
        height: 26,
        borderRadius: 13,
        position: 'relative',
        transition: 'background 0.2s',
        display: 'flex',
        alignItems: 'center',
    },
    switchThumb: {
        position: 'absolute',
        width: 20,
        height: 20,
        borderRadius: '50%',
        background: '#fff',
        boxShadow: '0 1px 4px rgba(0,0,0,0.18)',
        transition: 'transform 0.2s',
    },

    // Notifications
    notifList: {
        display: 'flex',
        flexDirection: 'column',
    },
    notifRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '14px 4px',
        borderBottom: '1px solid #f0f4e8',
        cursor: 'pointer',
        borderRadius: 8,
        transition: 'background 0.13s',
        gap: 16,
    },
    notifLabel: {
        fontSize: 14,
        fontWeight: 500,
        color: '#2c2c2c',
        marginBottom: 2,
    },
    notifDesc: {
        fontSize: 12,
        color: '#9ca3af',
    },
}